<template>
  <div v-show="userAuthorized">
    <div class="step-block__label">Адрес доставки</div>
    <select
        id="address-select"
        class="nice-select--search nice-select--normal"
        data-js-placeholder="Выберите сохраненный адрес">

      <option value="">Выберите сохраненный адрес</option>
      <option v-for="option in addresses" :key="option.ID" :value="option.ID">{{ option.ADDRESS_NAME }} / {{ option.NAME }}, {{ option.STREET }} {{ option.HOUSE }}</option>
    </select>

    <a class="edit-address_link" href="/personal/addresses">Редактировать адреса</a>
  </div>
</template>

<script>
import api from "@/api/address";

/* global $ */

export default {
  name: 'AddressSelect',
  data() {
    return {
      addresses: [],
      userAuthorized: false,
    }
  },
  mounted() {
    api.loadForCurrentUser(addresses => {
      this.userAuthorized = addresses.data.userAuthorized;
      this.addresses = addresses.data.addresses;
    });

    $('#address-select').change(() => {
      const selectedOption = $('#address-select').find('option:selected');
      const address = this.addresses.find((address) => address.ID === selectedOption.val());
      this.$emit('address-selected', address ?? {});
    });
  },
  updated() {
    $('#address-select').niceSelect('update');
  }
}
</script>